import pixNProgress from '@/shared/pixNProgress.js';
import store from '@/store/index.js';
import genericTabsPathConst from '@/consts/genericTabsPath.const';
import modeConst from '@/consts/mode.const.js';

/**
 * This guard prevents the loading of the specific property tab component when the tab does not included in the tab configuration by instance.
 */
const propertyManagementGuard = async (to, from, next) => {
  const propertyTabsPathsConst = genericTabsPathConst;
  try {
    store.dispatch('setMode', modeConst.PROPERTY);
    let property = store.getters['propertyModule/getProperty'];
    // Load property and tab configuration when the selected property is not loaded.
    if (property?.RowId !== to.params.rowId) {
      store.dispatch('loadingOverlayModule/setIsLoading', true);
      await store.dispatch('propertyModule/loadPropertyTabs');
      await store.dispatch('propertyModule/loadProperty', to.params.rowId);

      property = store.getters['propertyModule/getProperty'];
      store.dispatch('loadingOverlayModule/setIsLoading', false);
    }
    // Redirect to default tab in propertyManagement.

    const defaultTabId = store.getters['genericConfigModule/getGenericTabs'](modeConst.PROPERTY, property)[0]?.IdCategory;
    const defaultPropertyPath = propertyTabsPathsConst[defaultTabId] || propertyTabsPathsConst[1];

    // Check if the path is 3 levels deep to know if it has to redirect to the default tab or the path already contains a tab.
    if (to.matched.length !== 3) {
      next(`${to.path}/${defaultPropertyPath}`);
    } else {
      next();
    }
  } catch (error) {
    store.dispatch('toastModule/error', 'Error loading property');
    pixNProgress.forceFinish();
    next(false);
  }
};

export default propertyManagementGuard;
